import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import { VariableSelect } from './VariableSelect';

export const VariableSelectBridge = react2angular(VariableSelect, [
  'targetId',
  'steps',
  'enabled',
  'onValueSelected',
  'isPublicForm'
]);
